import './designBuild.css'
import { useSelector} from 'react-redux';
import { useState,useEffect } from "react";
import Designbuiled from '../../assets/designBuild.jpg';


function DesignBuild (){

  let boolean = useSelector((state) => state.boolean.bool)
  let [texte,setTexte]=useState()
  let [titre,setTitre]=useState()

  useEffect(() => {
    // Update the document title using the browser API
    if(boolean===false){
      setTexte(texteFR)
      setTitre(titreFR)
   }
   else{
    setTexte(texteANG)
    setTitre(titreENG)
   }
   console.log(texte)
  });

  //le textes en deux langues
  let texteFR="Lors de la conception de votre système audiovisuel, nous mettons l’accent sur l’expérience utilisateur finale tout en veillant à ce que chaque élément s’intègre parfaitement. Cela commence par une analyse approfondie de vos besoins spécifiques, pour associer les meilleurs choix de matériel et de logiciels afin de répondre exactement à vos attentes.  Nous sélectionnons avec soin des composants qui se connectent et se configurent sans problème, en tenant toujours compte du contexte d’installation et de toutes les variables susceptibles d’influencer les performances. Nous procédons ensuite à des tests rigoureux et à des réglages fins, pour garantir un fonctionnement fiable dès la mise en service. Discutons ensemble de la manière dont ce processus réfléchi peut donner vie à votre projet.";
  let texteANG="When designing your AV system, we focus on elevating the end-user experience while ensuring every element integrates without a hitch. This starts with a deep dive into your specific requirements, blending the ideal mix of hardware and software to deliver just what you need. We carefully choose components that connect and configure flawlessly, always factoring in the installation's context and any variables that might influence performance. We then rigorously test and fine-tune everything, confirming it works reliably right from the start. Let's explore how this thoughtful process can bring your vision to life.";
  
  let titreFR= "Systèmes audiovisuels intuitifs"
  let titreENG= "Seamless, User-Centred AV Systems"

  return (
    <section  className="designBuildSection">
      <div id="designBuildSectionId">
      </div>
      <div>
        <h3 className="designBuildTitle">{titre}</h3>
        <p>{texte}</p>
      </div>
      <div>

      </div>
      
    </section>
  )
}
export default DesignBuild;

